import { ORM } from "./CouchORM2";

export default class TemplateSlide extends ORM {
    static modelName = "TemplateSlide";
}